// @flow

import React, { type Element, useState } from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'
import { MuiThemeProvider } from '@material-ui/core/styles'
import EmailContainer from '../EmailContainer'
import PasswordContainer from '../PasswordContainer'
import theme from '../../../theme'
import AlertError from '../../Common/AlertError'
import AlertSuccess from '../../Common/AlertSuccess'
import { grey } from '@material-ui/core/colors'

type Props = {|
  currentEmail: string,
  serverErrors?: { [string]: Array<string> },
|}

function UserCredentialsContainer({
  currentEmail,
  serverErrors,
}: Props): Element<typeof MuiThemeProvider> {
  const [errors, setErrors] = useState(serverErrors)
  const [successMessage, setSuccessMessage] = useState('')
  const [email, setEmail] = useState(currentEmail)

  function handleServerErrors(errors: { [string]: Array<string> }): void {
    setErrors(errors)
  }

  function handleSuccess(field: string): void {
    setSuccessMessage(`${field} updated`)
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Grid item xs={12}>
        {errors && <AlertError errors={errors} />}
        {successMessage && <AlertSuccess message={successMessage} setMessage={setSuccessMessage} />}
      </Grid>
      <Container maxWidth="sm" disableGutters>
        <Box py={2} fontWeight="fontWeightMedium" color={grey[900]}>
          <Typography variant="h4" color="inherit">
            General
          </Typography>
        </Box>
        <Box width={1} pb={2}>
          <EmailContainer
            email={email}
            setEmail={setEmail}
            handleServerErrors={handleServerErrors}
            handleSuccess={handleSuccess}
          />
          <PasswordContainer
            handleServerErrors={handleServerErrors}
            handleSuccess={handleSuccess}
          />
        </Box>
      </Container>
    </MuiThemeProvider>
  )
}

export default UserCredentialsContainer
